// src/hooks/useBuildInfo.js
import { useEffect, useState } from 'react';

export function useBuildInfo() {
  const [info, setInfo] = useState({ version: '', buildDate: '' });

  useEffect(() => {
    fetch('/build-info.json')
      .then((res) => res.json())
      .then(setInfo)
      .catch(() => setInfo({ version: 'dev', buildDate: 'unknown' }));
  }, []);

  return info;
}
